import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/service/loader.service';
import { loaderWithContentService } from 'src/app/service/loaderWithContent.service';



@Component({
  selector: 'loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  sentences: string[] = [];
  selectedSentence: string;

  loading$ = this.loaderService.loading$;
  loadingWithContent$ = this.loadingWithContent.loadingWithContent$;
  loadingCnt$ = this.loaderService.loadingCnt$ 
  constructor(private loaderService: LoaderService, private http: HttpClient, private loadingWithContent: loaderWithContentService) { }
  ngOnInit() {

    this.loaderService.show();
    // Perform long-running operation
    this.loaderService.hide();

    this.fetchSentences();

    this.loaderService.loading$.subscribe((loading) => {
      if (loading) {
        this.onSelectRandomSentence();
      }
    });
  }


  fetchSentences(): void {
    this.http.get<any[]>('assets/jsons/info.json') // Adjust the path to your JSON file
      .subscribe(sentences => {
        this.sentences = sentences;
        this.onSelectRandomSentence()
      });
  }

  onSelectRandomSentence(): void {
    let randomIndex = 0;
    randomIndex = Math.floor(Math.random() * this.sentences.length);
    this.selectedSentence = this.sentences[randomIndex];
  }
}
